import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { ProfilePictureModal } from '../../modals/ProfilePictureModal'

class UpdateProfilePictureButtonComponent extends Component {
  constructor () {
    super()
    this.state = { open: false }
  }

  closeModal () {
    this.setState({ open: false })
  }

  openModal () {
    this.setState({ open: true })
  }

  render () {
    const { t } = this.props
    return (
      <div>
        <button onClick={() => this.setState({ open: true })} className='btn--green'>{t('common:buttons:modify_photo')}</button>
        <ProfilePictureModal isOpen={this.state.open} handleClose={() => this.closeModal()} />
      </div>
    )
  }
}

UpdateProfilePictureButtonComponent.propTypes = {
  t: func
}

export const UpdateProfilePictureButton = translate()(UpdateProfilePictureButtonComponent)



// WEBPACK FOOTER //
// ./src/components/ui/buttons/UpdateProfilePictureButton.js